import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import AdminProgressReports from "Administrator/routes/ProgressReportSetup/routes/AdminProgressReports";
import ProgressReportTemplate from "Administrator/routes/ProgressReportSetup/routes/ProgressReportTemplate";
import CommentTemplates from "Administrator/routes/ProgressReportSetup/routes/CommentTemplates";
import ChecklistSetup from "Administrator/routes/ProgressReportSetup/routes/Checklist";
import VoiceAndOutputStructure from "Administrator/routes/ProgressReportSetup/routes/VoiceAndOutputStructure";

export default store => ({
  path: "reporting-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    AdminProgressReports(store),
    ProgressReportTemplate(store),
    CommentTemplates(store),
    ChecklistSetup(store),
    VoiceAndOutputStructure(store),
  ],
});
